import { Button } from '@virtidev/toolbox';
import styled, { css } from 'styled-components';

export const ExtraWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const ChatInputWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
  display: flex;
  align-items: center;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: 0.2rem 1rem 0.2rem 1rem;
  display: flex;
  gap: 0.6rem;
  max-width: 900px;
  border: 1px solid rgba(0, 0, 0, 0);
  background: #fff;
  :focus-within {
    border: 1px solid ${(props) => props.theme.color.primary};
  }
  input,
  textarea {
    box-shadow: none !important;
  }

  ${
    /**
     * @param {{
     *    $disabled: boolean,
     * }} div
     */
    ({ $disabled }) =>
      $disabled &&
      css`
        opacity: 0.85;
        background: ${(props) => props.theme.color.blue50};
      `
  }
`;

export const SendButton = styled(Button)`
  padding: 0;
  width: 44px;
  height: 44px;
`;
